import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useCurrentPurchaseOrderContractTask } from '@/providers/PurchaseOrderContractTaskProvider';
import { useCurrentPurchaseOrder } from '@/providers/PurchaseOrderProvider';
import { PurchaseOrderContractTaskEditForm } from '@/components/features/tasks/purchase_order_contract/[purchase_order_contract_task_id]/PurchaseOrderContractTaskEditForm';

export const PurchaseOrderContractTaskEdit = () => {
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { _po_, mePurchaseOrderMember } = useCurrentPurchaseOrder();
  const { purchaseOrderContractTask: task } = useCurrentPurchaseOrderContractTask();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`契約申請（費用）タスク編集`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `プロジェクト（費用） - ${_t_!.name}`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders`,
        },
        {
          label: `プロジェクト（費用）詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}`,
        },
        {
          label: `契約申請（費用）タスク詳細`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders/${_po_!.id}/purchase_order_contract_tasks/${
            task!.id
          }`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <PurchaseOrderContractTaskEditForm />
    </WorkspaceLayout>
  );
};
